/** Display number for estimates — edge-safe (no supabase client). */
export function formatEstimateNumber(num, year) {
  if (num == null) return 'N/A';
  const y = year || new Date().getFullYear();
  return `EST-${y}-${String(num).padStart(4, '0')}`;
}

/**
 * Like formatEstimateNumber, but NEVER invents a year: with no stored year it
 * returns the bare padded number ("EST-0041"). For documents that must only
 * print facts the record carries (the PDF's legacy numeric snapshot fallback).
 */
export function formatEstimateNumberKnownYear(num, year) {
  if (num == null) return 'N/A';
  const pad = String(num).padStart(4, '0');
  return year ? `EST-${year}-${pad}` : `EST-${pad}`;
}
